
export default {
  props: {
    color: {
      type: String,
      default: null,
    },
    size: {
      type: [String, Number],
      default: 20,
    },
  },
  emits: ['back'],
};
